<template>
  <v-card class="full-width">
    <HeartbeatDetailsDialog ref="detailsDialog" />

    <ResendDialog v-model="showingDialog" :list="rows" />

    <v-toolbar flat dense class="card-bar">
      <v-toolbar-title>HBs a reenviar</v-toolbar-title>

      <v-spacer />

      <span style="width: 200px">
        <v-text-field
          v-model="fromHbId"
          prefix="Desde o HB"
          dense
          single-line
          hide-details
        />
      </span>

      <v-btn icon small @click="add(1)">+1</v-btn>

      <v-btn icon small @click="add(-1)">-1</v-btn>

      <v-spacer />

      <span style="width: 200px">
        <v-text-field
          v-model="untilHbId"
          prefix="Até o HB"
          dense
          single-line
          hide-details
        />
      </span>

      <v-spacer />

      <span> {{ total }} HBs, {{ withRawdata }} com rawdata </span>

      <v-btn text small class="ml-2" @click="preview">
        Preview
      </v-btn>
      <v-btn text small class="ml-2" color="red" @click="showingDialog = true">
        Resend all
      </v-btn>
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <v-simple-table>
      <colgroup>
        <col />
        <col width="100" />
        <col width="100" />
        <col width="100" />
      </colgroup>
      <thead>
        <tr class="children-text-right">
          <th class="text-left">Tipo</th>
          <th>HB ID</th>
          <th class="text-left">Indicadores</th>
          <th>RD Start</th>
          <th>RD Len</th>
          <th>RD End</th>
          <th>Timestamp</th>
        </tr>
      </thead>
      <tbody>
        <HbRow
          :hb="lastHbFromLastTrip"
          @click="(evt) => showDetails({ row: lastHbFromLastTrip.row, evt })"
        >
          <span class="hb-type orange" />
          Do último trecho
          <v-btn small icon class="ml-2" @click.stop="fetchLastHbFromLastTrip">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>

          <v-spacer />
          <span>{{ lastHbFromLastTrip.err }}</span>
        </HbRow>
        <HbRow
          :hb="lastHbFromReceipt.row"
          @click="(evt) => showDetails({ row: lastHbFromReceipt.row, evt })"
        >
          <span class="hb-type green" />
          Do último recibo
          <v-btn small icon class="ml-2" @click.stop="fetchLastHbFromReceipts">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>

          <v-spacer />
          <span>{{ lastHbFromReceipt.err }}</span>
        </HbRow>
        <HbRow
          v-for="(hb, index) in rows"
          :key="index"
          :hb="hb"
          @click="(evt) => showDetails({ row: hb, index, evt })"
        >
          <span
            class="hb-type orange"
            v-if="lastHbFromLastTrip.row && lastHbFromLastTrip.row.id == hb.id"
          />
          <span
            class="hb-type green"
            v-if="lastHbFromReceipt.row && lastHbFromReceipt.row.id == hb.id"
          />
        </HbRow>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import OLoadingLine from 'oderon-vue/cpts/OLoadingLine'
import HeartbeatDetailsDialog from '@/components/HeartbeatDetailsDialog'
import ResendDialog from './ResendDialog'
import UnpauserStore from './UnpauserStore'
import HbRow from './HbRow.vue'

export default {
  components: {
    OLoadingLine,
    ResendDialog,
    HeartbeatDetailsDialog,
    HbRow
  },
  computed: {
    isLoading() {
      return (
        UnpauserStore.lastHbFromLastTrip.isLoading ||
        UnpauserStore.lastHbFromReceipt.isLoading ||
        UnpauserStore.hbsToResend.isLoading
      )
    },
    lastHbFromLastTrip() {
      return UnpauserStore.lastHbFromLastTrip
    },
    lastHbFromReceipt() {
      return UnpauserStore.lastHbFromReceipt
    },
    rows() {
      return UnpauserStore.hbsToResend.rows
    },
    total() {
      return UnpauserStore.hbsToResend.total
    },
    withRawdata() {
      return UnpauserStore.hbsToResend.withRawdata
    },
    fromHbId: {
      get() {
        return UnpauserStore.hbsToResend.fromHbId
      },
      set(x) {
        UnpauserStore.hbsToResend.fromHbId = x
      }
    },
    untilHbId: {
      get() {
        return UnpauserStore.hbsToResend.untilHbId
      },
      set(x) {
        UnpauserStore.hbsToResend.untilHbId = x
      }
    }
  },
  data() {
    return {
      showingDialog: false
    }
  },
  methods: {
    preview() {
      UnpauserStore.fetchHbsToResend()
    },

    setFromHbId(fromHbId) {
      this.fromHbId = fromHbId
    },

    async fetchLastHbFromLastTrip() {
      let row = await UnpauserStore.fetchLastHbFromLastTrip()
      if (row != null) {
        UnpauserStore.hbsToResend.fromHbId = row.id + 1
        UnpauserStore.fetchHbsToResend()
      }
    },

    async fetchLastHbFromReceipts() {
      let row = await UnpauserStore.fetchLastHbFromReceipts()
      if (row != null) {
        UnpauserStore.hbsToResend.fromHbId = row.id + 1
        UnpauserStore.fetchHbsToResend()
      }
    },

    add(n) {
      if (!Number.isFinite(this.fromHbId)) return
      this.fromHbId = parseInt(this.fromHbId) + n
    },

    showDetails(row, index, evt) {
      if (evt && (evt.ctrlKey || evt.button == 1)) {
        window.open(`/#/heartbeats/${row.id}`, '_blank')
      } else {
        let hbId = row.id
        this.$refs.detailsDialog.open(hbId)
      }
    }
  }
}
</script>

<style lang="sass">
.hb-type
  // padding: 0 5px
  border-radius: 3px
  width: 8px
  height: 1.2em
  display: inline-block
  background-color: #ccc
  margin-right: 8px

  .orange
    background-color: orange

  .green
    background-color: green
</style>
